import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getResourcePlacesSearch } from '../../../javascript/api/resourcePlaces';
import AutocompleteFetchInput from '../../../javascript/presentation/components/inputs/autocomplete-fetch-input';
import { toOptions } from '../../../javascript/helpers/helpers';

const VIEW_MODE = ['Customer', 'Place', 'Resource'];

const ResourcePlacesFilter = ({ clearFilter, onChange, accountId, selectedIds = [] }) => {
  const [selectedResourcePlaceOptions, setSelectedResourcePlaceOptions] = useState(selectedIds.map((id) => ({ value: id, label: 'Carregando...' })));
  const initializedIds = useRef([]);
  const userPlan = window._currentPlan;
  const canViewResourcesAndLocations = userPlan !== 'padronizacao';

  const handleResourcePlaceChange = (data) => {
    const newIds = data.map((resourcePlace) => resourcePlace.value);
    initializedIds.current = newIds;
    setSelectedResourcePlaceOptions(data);
    onChange(newIds);
  };

  useEffect(() => {
    if (clearFilter) {
      setSelectedResourcePlaceOptions([]);
      initializedIds.current = [];
    }
  }, [clearFilter]);

  const fetchResourcePlaces = useCallback(async (q = "") => {
    try {
      const result = await getResourcePlacesSearch({ viewMode: VIEW_MODE, accountId, q });
      return toOptions(result.results);
    } catch (err) {
      console.error(err);
      return [];
    }
  }, [accountId]);

  useEffect(() => {
    if (
      !selectedIds.length || JSON.stringify(initializedIds.current) === JSON.stringify(selectedIds)
    ) {
      return;
    }

    initializedIds.current = [...selectedIds];

    getResourcePlacesSearch({ viewMode: VIEW_MODE, accountId, ids: selectedIds })
      .then((result) => setSelectedResourcePlaceOptions(toOptions(result.results)))
      .catch(console.error);
  }, [accountId, selectedIds]);

  return (
    <AutocompleteFetchInput
      label={!canViewResourcesAndLocations ? "Clientes" : "Clientes/Locais/Ativos"}
      value={selectedResourcePlaceOptions}
      setValue={handleResourcePlaceChange}
      fetchOptions={fetchResourcePlaces}
    />
  );
};

export default ResourcePlacesFilter;